import { useEffect } from "react";
import { useFileStore } from "../../../../store/useFileStore";

const DocMapsCategoryJson = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store);

    useEffect(() => {
        let value = `{
    "label": "Maps",
    "position": 7,
    "collapsible": false,
    "collapsed": false
}
        `;

        setStore({ docMapsCategoryJson: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default DocMapsCategoryJson;
